import React, { useState } from 'react';
import './HealthTwoGotFAQ.scss';
import { useCollection } from '../../../../firebase-files/hooks/useCollection';
import AddFaqs from '../../../../default-hooks/AddFaqs';


const HealthTwoGotFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const { documents } = useCollection("faqs")
  console.log(documents)

  const faqData = documents
    ? documents
        .filter(item => item.status === "active" )
        .sort((a, b) => a.order - b.order) 
        .slice(0, 5)
    : [];

  const toggleIndex = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="health-two-got-faq">
      <h2 className="health-two-section-heading">
          Got Questions?
        </h2>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            key={index}
            onClick={() => toggleIndex(index)}
          >
            <div className="faq-question">
              <span>{item.question}</span>
              <svg className="arrow-icon" width="20" height="20" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" fill="none" />
              </svg>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      <AddFaqs></AddFaqs>
    </section>
  );
};

export default HealthTwoGotFAQ;
